module.exports = __webpack_public_path__ + "static/tibet-3f00c818cbac4c1a5c0d0c68dbbf31d4.svg";